import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter/index.css';
import '@fontsource-variable/hanken-grotesk/index.css';
import '@fontsource/dm-serif-display/index.css';
import './index.css';
import App from './App.tsx';
import { initializeTheme } from './utils/theme';
import * as Sentry from "@sentry/react";
import { ServerHealthCheck } from './components/common/ServerHealthCheck';

Sentry.init({
  dsn: "https://b930815e9a7a572488429123cef0b0f2@sentry.sentra.be/4",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable logs to be sent to Sentry
  enableLogs: true,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ServerHealthCheck>
      <App />
    </ServerHealthCheck>
  </StrictMode>,
);

initializeTheme();